import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 15H20M4 19H13M4.75 12V11C4.75 9.89543 5.64543 9 6.75 9H10.75C11.8546 9 12.75 9.89543 12.75 11V12M10.5 4.5C10.5 5.4665 9.7165 6.25 8.75 6.25C7.7835 6.25 7 5.4665 7 4.5C7 3.5335 7.7835 2.75 8.75 2.75C9.7165 2.75 10.5 3.5335 10.5 4.5Z" />
	</SVG>
);
